import { CachedItem } from "./cached-item";

export type CacheOptions = {
    timeToLiveInMins?: number;
    usePrefix?: boolean;
    useLocalStorage?: boolean;
}

class Cache<T> {
    private _cache: CachedItem;
    private _items: Record<string, T> = {};

    constructor(name: string, options?: CacheOptions) {
        this._cache = cachedItemsFromOptions(name, options);

        this._initializeFromCache();
    }

    private _initializeFromCache() {
        if (!this._cache.isCached) {
            return;
        }

        this._items = this._cache.get() as Record<string, T> ?? {};
    }

    add(key: string, value: T) {
        this._items[key] = value;

        this._cache.set(this._items);
    }

    get(key: string) {
        return this._items[key];
    }
}

const cachedItemsFromOptions = (name: string, options?: CacheOptions) => {
    if (!options) {
        return new CachedItem(name);
    }

    const {
        timeToLiveInMins = 60,
        usePrefix = true,
        useLocalStorage = true
    } = options;

    const ttlInSecs = timeToLiveInMins * 60; 
    return new CachedItem(name, true, ttlInSecs, usePrefix, useLocalStorage);
}
export default Cache;